import { Decode } from "./stringTools.js";
/**
 * Utility class for reading from a data buffer
 */
var DataReader = /** @class */ (function () {
    /**
     * Constructor
     * @param buffer The buffer to read
     */
    function DataReader(buffer) {
        /**
         * The current byte offset from the beginning of the data buffer.
         */
        this.byteOffset = 0;
        this.buffer = buffer;
    }
    /**
     * Loads the given byte length.
     * @param byteLength The byte length to load
     * @returns A promise that resolves when the load is complete
     */
    DataReader.prototype.loadAsync = function (byteLength) {
        var _this = this;
        return this.buffer.readAsync(this.byteOffset, byteLength).then(function (data) {
            _this._dataView = new DataView(data.buffer, data.byteOffset, data.byteLength);
            _this._dataByteOffset = 0;
        });
    };
    /**
     * Read a unsigned 32-bit integer from the currently loaded data range.
     * @returns The 32-bit integer read
     */
    DataReader.prototype.readUint32 = function () {
        var value = this._dataView.getUint32(this._dataByteOffset, true);
        this._dataByteOffset += 4;
        this.byteOffset += 4;
        return value;
    };
    /**
     * Read a byte array from the currently loaded data range.
     * @param byteLength The byte length to read
     * @returns The byte array read
     */
    DataReader.prototype.readUint8Array = function (byteLength) {
        var value = new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + this._dataByteOffset, byteLength);
        this._dataByteOffset += byteLength;
        this.byteOffset += byteLength;
        return value;
    };
    /**
     * Read a string from the currently loaded data range.
     * @param byteLength The byte length to read
     * @returns The string read
     */
    DataReader.prototype.readString = function (byteLength) {
        return Decode(this.readUint8Array(byteLength));
    };
    /**
     * Skips the given byte length the currently loaded data range.
     * @param byteLength The byte length to skip
     */
    DataReader.prototype.skipBytes = function (byteLength) {
        this._dataByteOffset += byteLength;
        this.byteOffset += byteLength;
    };
    return DataReader;
}());
export { DataReader };
//# sourceMappingURL=dataReader.js.map